<template>
  <div>
    <b-row style="margin: 5px;">
      <b-form-group>
        <label style="font-weight: bold;">1. Question Font Size Settings:</label>
        <div style="display: flex; align-items: center;">
          <b-form-select style="width: 100px; margin-right: 5px;" v-model="zoomLevel" :options="zoomOptions"
            value-field="value" text-field="text" :disabled="!editZoomLevel"></b-form-select>

          <!-- Update button -->
          <button v-if="editZoomLevel" class="btn btn-success btn-sm mr-2" @click="setQuestionPaperZoomLevel()">
            Update
          </button>

          <!-- Cancel button -->
          <button v-if="editZoomLevel" class="btn btn-danger btn-sm mr-2" @click="cancelEditZoomLevel">
            Cancel
          </button>

          <!-- Edit icon -->
          <i v-if="!editZoomLevel" class="fas fa-edit text-info" style="font-size: 15px !important; cursor: pointer;"
            @click="enableZoomEdit"></i>
        </div>

        <span style="display: block; margin-top: 5px; zoom: zoomLevel;">
          "Preview Text: Check font size visibility."
        </span>
      </b-form-group>
    </b-row>
    <b-row style="margin: 5px;">
      <b-form-group>
        <label style="font-weight: bold;">2. Signature Field Settings:</label>
        <!-- Main Table for Signature Field Settings -->
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No</th>
              <th>Signature Field</th>
              <th>Signed Officials</th>
            </tr>
          </thead>
          <tbody>
            <!-- Looping through signature fields -->
            <tr v-for="(field, index) in signatureFields" :key="index">
              <td>{{ index + 1 }}</td> <!-- Displaying serial number -->

              <td class="d-flex align-items-center justify-content-between">
                <span>{{ formatFieldName(field.name) }}</span>
                <!-- + Icon to Add Role -->
                <i class="fas fa-plus-square text-primary" style="cursor: pointer; font-size: 16px;"
                  @click="addNewRoleAndSignatureField(field.name)">
                </i>
              </td>

              <td>
                <!-- Nested Table for Signed Officials -->
                <table class="table table-borderless">
                  <tbody>
                    <!-- Looping through signed officials for each field -->
                    <template v-for="(role, roleKey) in field.signed_officials">
                      <tr :key="roleKey">
                        <td style="width: 300px;">
                          <div class="d-flex align-items-center justify-content-between">
                            <!-- Show display text only when not editing -->
                            <span v-if="!(
                              isEditingRole[field.name] &&
                              isEditingRole[field.name][roleKey]
                            ) && (
                                roleKey === 'prepared_by' ||
                                roleKey === 'verified_by' ||
                                roleKey === 'approved_by'
                              )">
                              {{ formatRoleName(roleKey) }}
                            </span>
                            <!-- Optional fallback for dynamic roles -->
                            <span v-else-if="!roleOptions.find(opt => opt.id === roleKey)" style="color:red">
                              Click edit icon to add
                            </span>

                            <!-- Edit, Add, and Remove Icons -->
                            <div class="d-flex"
                              v-if="!isEditingRole[field.name] || !isEditingRole[field.name][roleKey]">

                              <i class="fas fa-edit text-info ml-2" style="cursor: pointer; 
                          font-size: 14px!important;margin-right: 10px;"
                                @click.stop="enableRoleEditing(field.name, roleKey)">
                              </i>


                              <i class="fas fa-plus-square text-success ml-2" style="cursor: pointer; 
                          font-size: 14px!important;margin-right: 10px;"
                                @click="addSignatureField(field.name, roleKey)">
                              </i>
                              <i class="fas fa-minus-circle text-danger ml-2" style="cursor: pointer; 
                          font-size: 14px!important;margin-right: 50px;"
                                @click="removeNewRoleAndSignatureField(field.name, roleKey)">

                              </i>
                            </div>


                          </div>

                          <!-- Show select box for role when in edit mode -->
                          <div v-if="isEditingRole[field.name] && isEditingRole[field.name][roleKey]"
                            class="d-flex align-items-center mt-2">
                            <b-form-select v-model="selectedRole[field.name][roleKey]" :options="roleOptions"
                              value-field="id" text-field="name" style="width: 250px;" class="mr-2">
                            </b-form-select>
                            <button class="btn btn-success btn-sm" @click="updateRole(field.name, roleKey)">
                              Update
                            </button>
                            <button class="btn btn-danger btn-sm" @click="cancelUpdateRole(field.name, roleKey)">
                              Cancel
                            </button>
                          </div>
                        </td>
                        <td>
                          <!-- Officials under this role -->
                          <div v-for="(official, idx) in role" :key="idx" class="d-flex flex-column">
                            <div
                              v-if="!isEditing[field.name] || !isEditing[field.name][roleKey] || !isEditing[field.name][roleKey][idx]"
                              class="d-flex align-items-center justify-content-between">
                              <span v-if="official">{{ getSignatureName(official) }}</span>
                              <span v-else style="color:red">Click edit icon to add</span>

                              <div class="d-flex">
                                <!-- Edit Icon -->
                                <i class="fas fa-edit text-info ml-2"
                                  style="cursor: pointer; font-size: 14px!important; margin-right: 10px;"
                                  @click.stop="enableEditing(field.name, roleKey, idx)">
                                </i>

                                <!-- Minus/Delete Icon -->
                                <i class="fas fa-minus-circle text-danger ml-2"
                                  style="cursor: pointer; font-size: 14px!important;"
                                  @click="removeOfficial(field.name, roleKey, idx)">
                                </i>
                              </div>

                            </div>

                            <!-- Official Select Box -->
                            <div v-if="isEditing[field.name] &&
                              isEditing[field.name][roleKey] &&
                              isEditing[field.name][roleKey][idx]" class="d-flex align-items-center mt-2">
                              <b-form-select v-model="field.signed_officials[roleKey][idx]" :options="signatureOptions"
                                value-field="id" text-field="name" style="width: 250px;" class="mr-2">
                              </b-form-select>
                              <button class="btn btn-success btn-sm"
                                @click="updateOfficial(field.name, roleKey, idx)">Update</button>
                              <button class="btn btn-danger btn-sm"
                                @click="cancelEditOfficial(field.name, roleKey)">Cancel</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </b-form-group>
    </b-row>

    <b-row style="margin: 5px;">
      <b-form-group>
        <label style="font-weight: bold;">
          3. Activity Question Paper Mapping
        </label>

        <div style="display: flex; flex-direction: column; margin-top: 10px;">

          <!-- CO -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralCo"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Course Outcome (CO) mapping in activity question paper</span>
          </div>

          <!-- PO -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralPo"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Programme Outcome (PO) mapping in activity question paper</span>
          </div>

          <!-- PSO -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralPso"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Programme Specific Outcome (PSO) mapping in activity question paper</span>
          </div>

          <!-- ML -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralMl"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Module (ML) mapping in activity question paper</span>
          </div>
        </div>

        <!-- Common Actions -->
        <div style="margin-top: 10px;">
          <button
            v-if="editDisplayOnlyNumeral"
            class="btn btn-success btn-sm mr-2"
            @click="updateAllDisplayOnlyNumeral"
          >
            Update
          </button>

          <button
            v-if="editDisplayOnlyNumeral"
            class="btn btn-danger btn-sm mr-2"
            @click="cancelEditDisplayOnlyNumeral"
          >
            Cancel
          </button>

          <i
            v-if="!editDisplayOnlyNumeral"
            class="fas fa-edit text-info"
            style="font-size: 15px !important; cursor: pointer;"
            @click="enableDisplayOnlyNumeralEdit"
          ></i>
        </div>
      </b-form-group>
    </b-row>

  </div>

</template>

<script>
export default {
  props: ["usergroup_id"],
  async created() {
    await this.getQuestionPaperZoomLevel();
    await this.getQuestionPaperSignatureFieldSigningOfficials();
    await this.loadDisplayOnlyNumeralSettings();
  },
  data() {
    return {
      displayOnlyNumeralCo: false,
      displayOnlyNumeralPo: false,
      displayOnlyNumeralPso: false,
      displayOnlyNumeralMl: false,
      editDisplayOnlyNumeral: false,
      backupDisplayOnlyNumeral: {}, // store backup values for cancel
      backupOfficialValues: {},
      backupRoleKeys: {},
      previousZoomLevel: null,
      editZoomLevel: false,
      zoomOptions: [
        { value: 1.25, text: '1.25' },
        { value: 1.3, text: '1.3' },
        { value: 1.35, text: '1.35' },
        { value: 1.4, text: '1.4' },
        { value: 1.45, text: '1.45' },
        { value: 1.5, text: '1.5' },
      ],
      zoomLevel: 1.3,
      isEditing: {},
      // Options for the signature select dropdown
      signatureOptions: [
        { id: 'course_in_charge', name: 'Course-in-Charge' },
        { id: 'advisor', name: 'Advisor' },
        { id: 'HOD', name: 'HOD' },
        { id: 'DQAC', name: 'DQAC' },
        { id: 'principal', name: 'Principal' },
        { id: 'IQAC', name: 'IQAC' },
        { id: 'stream_coordinator', name: 'Stream Coordinator' }
      ],
      // Updated signatureFields: each official field is now an array
      signatureFields: [],
      isEditingRole: {},  // Object to track role edit mode
      selectedRole: {},    // Store the selected role during editing
      roleOptions: [
        { id: 'prepared_by', name: 'Prepared By' },
        { id: 'verified_by', name: 'Verified By' },
        { id: 'approved_by', name: 'Approved By' },
      ]
    };
  },
  computed: {
    // Returns the display name for a given signature id.
    getSignatureName() {
      return (id) => {
        const option = this.signatureOptions.find(option => option.id === id);
        return option ? option.name : id;
      };
    }
  },
  methods: {
    async loadDisplayOnlyNumeralSettings() {
      try {
        const [coRes, poRes, psoRes, mlRes] = await Promise.all([
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_co`),
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_po`),
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_pso`),
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_ml`),
        ]);

        this.displayOnlyNumeralCo = coRes.data == 1;
        this.displayOnlyNumeralPo = poRes.data == 1;
        this.displayOnlyNumeralPso = psoRes.data == 1;
        this.displayOnlyNumeralMl = mlRes.data == 1;
      } catch (e) {
        // fallback defaults
        this.displayOnlyNumeralCo = false;
        this.displayOnlyNumeralPo = false;
        this.displayOnlyNumeralPso = false;
        this.displayOnlyNumeralMl = false;
      }
    },

    enableDisplayOnlyNumeralEdit() {
      this.backupDisplayOnlyNumeral = {
        co: this.displayOnlyNumeralCo,
        po: this.displayOnlyNumeralPo,
        pso: this.displayOnlyNumeralPso,
        ml: this.displayOnlyNumeralMl,
      };
      this.editDisplayOnlyNumeral = true;
    },

    cancelEditDisplayOnlyNumeral() {
      this.displayOnlyNumeralCo = this.backupDisplayOnlyNumeral.co;
      this.displayOnlyNumeralPo = this.backupDisplayOnlyNumeral.po;
      this.displayOnlyNumeralPso = this.backupDisplayOnlyNumeral.pso;
      this.displayOnlyNumeralMl = this.backupDisplayOnlyNumeral.ml;
      this.editDisplayOnlyNumeral = false;
    },

    async updateAllDisplayOnlyNumeral() {
      try {
        await Promise.all([
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_co`,
            { display_only_numeral_co: this.displayOnlyNumeralCo }
          ),
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_po`,
            { display_only_numeral_po: this.displayOnlyNumeralPo }
          ),
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_pso`,
            { display_only_numeral_pso: this.displayOnlyNumeralPso }
          ),
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups/setting/${this.usergroup_id}/display_only_numeral_ml`,
            { display_only_numeral_ml: this.displayOnlyNumeralMl }
          ),
        ]);
        this.$toast.success("Updated Display Only Numeral Settings", {
          position: "top",
          duration: 3000,
        });
        this.editDisplayOnlyNumeral = false;
      } catch (e) {
        this.$toast.error("Failed to update settings", {
          position: "top",
          duration: 3000,
        });
      }
    },

    enableZoomEdit() {
      this.previousZoomLevel = this.zoomLevel; // Save original value
      this.editZoomLevel = true;
    },
    cancelEditZoomLevel() {
      this.zoomLevel = this.previousZoomLevel; // Revert to original
      this.editZoomLevel = false;
    },
    addSignatureField(fieldName, roleKey) {
      const field = this.signatureFields.find(field => field.name === fieldName);

      if (field) {
        // Ensure signed_officials exists
        if (!field.signed_officials[roleKey]) {
          this.$set(field.signed_officials, roleKey, []);
        }

        // Add a new empty role (null)
        field.signed_officials[roleKey].push(null);
        this.$forceUpdate();
      }
    },
    addNewRoleAndSignatureField(name) {
      const field = this.signatureFields.find(f => f.name === name);
      if (!field) return;

      // Fix if signed_officials is missing or not an object
      if (
        !field.signed_officials ||
        typeof field.signed_officials !== 'object' ||
        Array.isArray(field.signed_officials)
      ) {
        this.$set(field, 'signed_officials', {});
      }

      // Count existing dynamic new_X keys
      const newKeys = Object.keys(field.signed_officials).filter(key => key.startsWith('new_'));
      if (newKeys.length >= 4) {
        alert('Maximum limit of 4 additional signed officials reached.');
        return;
      }

      // Add the first available new_X key
      for (let i = 1; i <= 4; i++) {
        const key = `new_${i}`;
        if (!(key in field.signed_officials)) {
          this.$set(field.signed_officials, key, [null]); // Add with default string value
          this.$forceUpdate();
          return;
        }
      }
    },

    removeNewRoleAndSignatureField(name, index) {
      const field = this.signatureFields.find(field => field.name === name);
      if (!field) return;
      delete field.signed_officials[index];
      this.setQuestionPaperSignatureFieldSigningOfficials(name, field.signed_officials);
      this.$forceUpdate();
    },

    removeOfficial(fieldName, roleKey, idx) {
      const field = this.signatureFields.find(f => f.name === fieldName);
      if (!field || !field.signed_officials[roleKey]) return;

      // Remove the official at the specific index
      field.signed_officials[roleKey].splice(idx, 1);

      // Save the updated list
      this.setQuestionPaperSignatureFieldSigningOfficials(fieldName, field.signed_officials);
    },

    enableRoleEditing(fieldName, roleKey) {
      // Initialize editing tracker
      if (!this.isEditingRole[fieldName]) {
        this.$set(this.isEditingRole, fieldName, {});
      }
      this.$set(this.isEditingRole[fieldName], roleKey, true);

      // Initialize selectedRole
      if (!this.selectedRole[fieldName]) {
        this.$set(this.selectedRole, fieldName, {});
      }

      // Set default selected value
      this.selectedRole[fieldName][roleKey] = roleKey;

      // Backup original roleKey
      if (!this.backupRoleKeys[fieldName]) {
        this.$set(this.backupRoleKeys, fieldName, {});
      }

      this.$set(this.backupRoleKeys[fieldName], roleKey, roleKey);
    },

    cancelUpdateRole(fieldName, roleKey) {
      if (!this.isEditingRole[fieldName]) return;

      // Revert roleKey to the backed-up original
      const originalRoleKey = this.backupRoleKeys?.[fieldName]?.[roleKey];

      if (originalRoleKey && roleKey !== originalRoleKey) {
        const field = this.signatureFields.find(f => f.name === fieldName);
        if (field && field.signed_officials[roleKey]) {
          // Move data back
          this.$set(field.signed_officials, originalRoleKey, field.signed_officials[roleKey]);
          this.$delete(field.signed_officials, roleKey);
        }
      }

      // Exit editing mode
      this.$set(this.isEditingRole[fieldName], roleKey, false);

      // Clean backup
      if (this.backupRoleKeys[fieldName]) {
        this.$delete(this.backupRoleKeys[fieldName], roleKey);
      }
    },

    updateRole(fieldName, roleKey) {
      let newRole = this.selectedRole[fieldName][roleKey];

      let field = this.signatureFields.find(f => f.name === fieldName);

      if (field && field.signed_officials[roleKey]) {
        const updatedSignedOfficials = {};

        Object.keys(field.signed_officials).forEach((key) => {
          if (key === roleKey) {
            updatedSignedOfficials[newRole] = field.signed_officials[roleKey];
          } else {
            updatedSignedOfficials[key] = field.signed_officials[key];
          }
        });

        field.signed_officials = updatedSignedOfficials;

        // Clear the editing state only for the updated role
        if (this.isEditingRole[fieldName]) {
          this.$set(this.isEditingRole[fieldName], roleKey, false);
          this.$set(this.selectedRole[fieldName], roleKey, null);
        }

        this.setQuestionPaperSignatureFieldSigningOfficials(fieldName, field.signed_officials);
      }
    },
    updateOfficial(fieldName, roleKey, idx) {
      // Get the specific field
      const field = this.signatureFields.find(f => f.name === fieldName);
      if (!field || !field.signed_officials[roleKey]) return;

      // Optional: Validate or process the updated official value if needed

      // Clear edit state only for the specific official
      if (this.isEditing[fieldName] &&
        this.isEditing[fieldName][roleKey] &&
        this.isEditing[fieldName][roleKey][idx] !== undefined) {
        this.$set(this.isEditing[fieldName][roleKey], idx, false);
      }

      this.setQuestionPaperSignatureFieldSigningOfficials(fieldName, field.signed_officials);
    },

    formatRoleName(roleKey) {
      const roleMap = {
        prepared_by: "Prepared By",
        verified_by: "Verified By",
        approved_by: "Approved By",
      };
      return roleMap[roleKey] || roleKey;
    },
    formatFieldName(name) {
      return name
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },

    // Enable edit mode for a specific role in a field.
    enableEditing(fieldName, roleKey, index) {
      if (!this.isEditing[fieldName]) {
        this.$set(this.isEditing, fieldName, {});
      }

      if (!this.isEditing[fieldName][roleKey]) {
        this.$set(this.isEditing[fieldName], roleKey, {});
      }

      // Clear previous index states under this roleKey
      Object.keys(this.isEditing[fieldName][roleKey]).forEach(i => {
        this.$set(this.isEditing[fieldName][roleKey], i, false);
      });

      this.$set(this.isEditing[fieldName][roleKey], index, true);

      // Backup original value
      if (!this.backupOfficialValues[fieldName]) {
        this.$set(this.backupOfficialValues, fieldName, {});
      }
      if (!this.backupOfficialValues[fieldName][roleKey]) {
        this.$set(this.backupOfficialValues[fieldName], roleKey, {});
      }

      const originalValue = this.signatureFields
        .find(f => f.name === fieldName)
        .signed_officials[roleKey][index];

      this.$set(this.backupOfficialValues[fieldName][roleKey], index, originalValue);
    },

    cancelEditOfficial(fieldName, roleKey) {
      if (
        this.isEditing[fieldName] &&
        this.isEditing[fieldName][roleKey] &&
        this.backupOfficialValues[fieldName] &&
        this.backupOfficialValues[fieldName][roleKey]
      ) {
        const field = this.signatureFields.find(f => f.name === fieldName);
        const role = field?.signed_officials[roleKey];

        if (Array.isArray(role)) {
          Object.keys(this.isEditing[fieldName][roleKey]).forEach(index => {
            if (this.backupOfficialValues[fieldName][roleKey][index] !== undefined) {
              this.$set(
                field.signed_officials[roleKey],
                index,
                this.backupOfficialValues[fieldName][roleKey][index]
              );
            }

            this.$set(this.isEditing[fieldName][roleKey], index, false);
          });
        }
      }
    },

    async getQuestionPaperSignatureFieldSigningOfficials() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usergroups/questionpapersignaturefield?usergroup_id=${this.usergroup_id}`;
      try {
        const response = await this.$axios.get(url);
        if (response.data) {
          this.signatureFields = response.data;
        }
      } catch (error) {
        console.error("Error fetching signature field data:", error);
      }
    },
    getQuestionPaperZoomLevel() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/setting/${this.usergroup_id}/question_paper_zoom_level`;
      this.$axios
        .get(url)
        .then((response) => {
          this.zoomLevel = parseFloat(response.data) || 1.3;
        })
        .catch(() => {
          this.zoomLevel = 1.3;
        });
    },

    async setQuestionPaperSignatureFieldSigningOfficials(report_name, signedOfficials) {
      try {
        const url =
          this.$store.getters.getAPIKey.mainAPI +
          `/usergroups/questionpapersignaturefield?usergroup_id=${this.usergroup_id}`;
        await this.$axios.post(url, {
          usergroup_id: this.usergroup_id,
          report_name: report_name,
          signed_officials: signedOfficials,
        });

        this.$toast.success("Updated Question Paper Signature Field Settings", {
          position: "top",
          duration: 3000,
        });

      } catch (error) {
        this.$toast.error("Failed to update settings", { position: "top", duration: 3000 });
        console.error("Error updating signature field settings:", error);
      }
    },

    async setQuestionPaperZoomLevel() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups/setting/${this.usergroup_id}/question_paper_zoom_level`;
      await this.$axios
        .post(url, { question_paper_zoom_level: this.zoomLevel })
        .then(() => {
          this.editZoomLevel = false;
          this.$toast.success("Updated Question Paper Zoom Level", {
            position: "top",
            duration: 3000,
          });
        });
    },
  },
};
</script>
